import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { translate, formatData, getUserNameToName, showMessageToastCustom } from '../../../utils/util';
import ButtonUI from '../../../components/UI/ButtonUI';
import InputUI from '../../../components/UI/InputUI';
import ConfigurationService from '../../../services/ConfigurationService';
import { validateInputsRequired, onValueChange } from '../../../utils/handleChangeHooks';
import Select from '../../../components/UI/Select';
import Breadcrumbs from '../../../components/UI/Breadcrumbs';

const ResourceInsert = (props) => {
    const update = props.location?.state?.update;
    const [sheds, setSheds] = useState([])
    const [resource, setResource] = useState(props.location?.state?.update && props.resource ? props.resource
        : { active: true, resourceAreas: [] });

    useEffect(() => {
        document.addEventListener('keydown', handleFormKeyDown);
        if (!resource.resourceAreas) {
            resource.resourceAreas = [];
            setResource({ ...resource });
        }

        props.getPrints(props.user.vision, {});
        return () => {
            document.removeEventListener('keydown', handleFormKeyDown);
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (props.sheds) {
            const unique = [...new Set(props.sheds.map(item => item.areaId))];
            setSheds(unique.map((i) => { return { id: i, text: props.sheds.find((f) => f.areaId === i).text }; }));
        }
        // eslint-disable-next-line
    }, [props.sheds]);

    const handleFormKeyDown = (event) => {
        if ((event.key === 'Enter' || event.keyCode === 13)) {
            event.preventDefault();
            onConfirm();
        }
    }

    const redirect = () => {
        props.history.replace('./list');
    }

    const onChange = (event) => {
        onValueChange(event, resource, setResource);
    };

    const addAreas = (item) => {
        if (item.target?.value && !resource.resourceAreas?.find((f) => Number(item.target?.value) === Number(f))) {
            resource.resourceAreas.push(Number(item.target?.value));
            setResource({ ...resource });
        }
    };

    const removedAreas = (id) => {
        const items = resource.resourceAreas?.filter((item) => Number(item) !== Number(id));
        if (items) {
            resource.resourceAreas = items;
            setResource({ ...resource });
        }
    }

    const onConfirm = () => {
        if (validateInputsRequired()) {
            if (!resource.resourceAreas || resource.resourceAreas.length <= 0) {
                return showMessageToastCustom(
                    translate('general:warning'), translate('validations:select-shed'), 3000, 'mdi mdi-alert-circle-outline red-text');
            }

            if (update) {
                props.resourceServicePut(props.user.vision, resource, () => {
                    redirect();
                });
            } else {
                props.resourceServicePost(props.user.vision, resource, () => {
                    redirect();
                });
            }
        }
    };

    const titleResource = { icon: "mdi mdi-clipboard-check-outline", label: translate('menu.configuration', 'configuration') };

    const subtitlesResource = () => {
        let subtitlesItems = [];
        subtitlesItems = [...subtitlesItems, { icon: "mdi mdi-select-group", label: translate('menu.queue', 'configuration') }];
        subtitlesItems = [...subtitlesItems, { label: update ? translate('menu.update', 'configuration') : translate('menu.insert', 'configuration') }];
        return subtitlesItems;
    }

    return (
        <div>
            <Breadcrumbs id="resourceInsert" title={titleResource} subtitles={subtitlesResource()} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <div className="card">
                        <div className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                            <form>
                                <div className="row" style={{ marginBottom: '0px' }}>
                                    <div className="input-field no-padding col s12">
                                        <InputUI
                                            required
                                            label={translate('fields.name', 'resource')}
                                            id="name"
                                            name="name"
                                            type="text"
                                            onChange={onChange}
                                            value={resource?.name} />
                                    </div>
                                    <div className="input-field no-padding col s12">
                                        <InputUI
                                            label={translate('fields.clickResourceName', 'resource')}
                                            id="clickResourceName"
                                            name="clickResourceName"
                                            type="text"
                                            onChange={onChange}
                                            numericonly="true"
                                            maxLength={4}
                                            value={resource?.clickResourceName} />
                                    </div>
                                    <div className="input-field no-padding col s12">
                                        <Select
                                            required
                                            id="printerId"
                                            name="printerId"
                                            placeHolder={translate('fields.print', 'resource')}
                                            defaultValue={resource?.printerId || ""}
                                            data={props.prints?.items ? props.prints?.items.map((i) => { return { id: i.printerId, text: i.name }; }) : []}
                                            change={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s12">
                                        <InputUI
                                            type="checkbox"
                                            label={translate('fields.active', 'resource')}
                                            id="active" name="active"
                                            onChange={onChange}
                                            defaultChecked={resource?.active} />
                                    </div>
                                    <div className="input-field no-padding col s12">
                                        <Select
                                            id="shed"
                                            name="shed"
                                            display="description"
                                            defaultValue={""}
                                            change={addAreas}
                                            placeHolder={`Galpão - ${translate('general:choose-one-option')}`}
                                            data={sheds}
                                        />
                                    </div>
                                    {
                                        sheds.length > 0 && resource.resourceAreas && resource.resourceAreas.map((item, index) =>
                                            <div key={`${item}-col${index}`} className="no-padding col s12">
                                                <div key={`${item}-div${index}`} className="list sixth-text-color">
                                                    <i onClick={() => removedAreas(item)} className={`mdi mdi-21px mdi-alpha-x-circle-outline`} />
                                                    {sheds.find((f) => Number(f.id) === Number(item))?.text}
                                                </div>
                                            </div>)
                                    }
                                </div>
                            </form>
                            {
                                resource?.resourceId > 0 ? (
                                    <div className="row">
                                        <div className="input-field no-padding col s5">
                                            <span className="field f-1r truncate">{resource?.createBy}</span>
                                            <label className="active" htmlFor="nivel">{translate('fields.createBy', 'resource')}: </label>
                                        </div>
                                        <div className="input-field no-padding col s6">
                                            <span className="field f-1r truncate">{getUserNameToName(props?.usersFromElog, resource?.updateBy)}</span>
                                            <label className="active" htmlFor="nivel">{translate('fields.updateBy', 'resource')}</label>
                                        </div>
                                        <div className="input-field no-padding col s6">
                                            <span className="field f-1r truncate">{formatData(resource?.updateOn)}</span>
                                            <label className="active" htmlFor="nivel">{translate('fields.updateOn', 'resource')}</label>
                                        </div>
                                    </div>
                                ) : null
                            }
                            <div className="row">
                                <ButtonUI onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                                <ButtonUI onClick={() => onConfirm()} text={translate('confirm', 'general')} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        sheds: state.configReducer.sheds,
        user: state.userReducer.user,
        resource: state.configReducer.resource,
        prints: state.configReducer.prints,
        usersFromElog: state.usersElogReducer.usersElog
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        resourceServicePost: (vision, resource, callback) => {
            dispatch(ConfigurationService.PostResources(vision, resource, callback));
        },
        resourceServicePut: (vision, resource, callback) => {
            dispatch(ConfigurationService.PutResources(vision, resource, callback));
        },
        getPrints: (vision, filter) => {
            dispatch(ConfigurationService.getPrints(vision, filter));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ResourceInsert)));

